app.factory('p2DrugModel', ['$rootScope', 'baseModel', 'p2DrugService',
    function($rootScope, baseModel, p2DrugService) {

	    function P2DrugModel() {

			this.getDataPage = function(criteria) {
				p2DrugService.getDataPage(criteria).then(
					function (dataPage) {
						$rootScope.$broadcast(Event.P2_DRUG.GET_DATA_PAGE.SUCCESS, dataPage);
					},
					function(error) {
						$rootScope.$broadcast(Event.P2_DRUG.GET_DATA_PAGE.ERROR, error);
					}
				)
			};
	
	    }
	
	    return new P2DrugModel();
	}
]);
